export const app_i18n = {
  text1:
    "Scannen Sie die Rückseite Ihres Personalausweises oder die Seite Ihres Reisepasses mit Ihrem Foto",
  text2: "Haben Sie Probleme mit dem Scanner?",
  text3: "Erneut versuchen",
  text4: "Manueller Vorgang",
  text5: "Willkommen!!",
  text6: "Wählen Sie das Aufenthaltsdatum",
  text7: "Ihre E-Mail",
  text8: "Weiter",
  text9: "Los geht's! Fast geschafft",
  text10: "Willkommen",
  text11: "Willkommen",
  text12: "Telefon",
  text13:
    "Um fortzufahren, müssen Sie unsere Allgemeinen Geschäftsbedingungen akzeptieren.",
  text14: "Ich akzeptiere die Allgemeinen Geschäftsbedingungen",
  text15: "Weiter",
  text16: "Sie können im grauen Feld auf dem Bildschirm unterschreiben",
  text17: "Löschen",
  text18: "Unterschrift speichern",
  text19: "Bitte unterschreiben Sie",
  text20: "Check-in erfolgreich abgeschlossen",
  text21:
    "Vielen Dank, wir haben eine Kopie des unterschriebenen Dokuments an Ihr WhatsApp gesendet",
  text22: "Möchten Sie einen weiteren Check-in durchführen?",
  text23: "Von vorn beginnen",
  text24: "Willkommen  🤗",
  text25: "😃 Bitte geben Sie die folgenden Daten ein",
  text26: "Vorname",
  text27: "Nachname",
  text28: "Geschlecht auswählen",
  text29: "Geschlecht",
  text30: "Männlich",
  text31: "Weiblich",
  text32: "Geburtsdatum",
  text33: "Los geht's! Fast geschafft 😉",
  text34: "Wählen Sie das Aufenthaltsdatum.",
  text35: "E-Mail",
  text36: "Ausweisnummer eingeben",
  text37: "Dokumentart",
  text38: "AUSWEIS",
  text39: "REISEPASS",
  text40: "Dokumentnummer eingeben",
  text41: "Sie müssen ein Land auswählen",
  // here
  text42: "Länder",
  text43: "Liste der verfügbaren Services der Unterkunft",
  text44: "Services werden geladen ...",
  text45: "Keine Services verfügbar",
  text46: "Serviceanfrage erfolgreich gesendet",
  text47: "Ein Mitarbeiter wird sich bei Ihnen melden, um die Serviceanfrage abzuschließen.",
  text48: "Zurück",
  text49:
    "Serviceanfrage erfolgreich gesendet, ein Betreuer wird sich in Kürze bei Ihnen melden.",
  text50: "Preis",
  text51: "Servicebeschreibung",
  text52: "Anfragen",
  text53: "Serviceanfrage senden",
  text54: "Nach dem Senden der Anfrage meldet sich ein Betreuer bei Ihnen",
  text55: "Senden",
  text56: "Serviceanfrage erfolgreich gesendet.",
  text57: "Fehler, der Service konnte nicht angefragt werden",
  text58: "Check-in-Daten werden gesendet, bitte warten...",
  text59: "Wird geladen...",
  text60: "hat den Check-in erfolgreich abgeschlossen.",
  text61: `🎁 Klicken Sie hier, um alle verfügbaren Services im Hotel zu sehen`,
  text62: "Anmeldung",
  text63: "Keine Angabe",
  text64: "Divers",
  text65: "Land",
  text66: "Fehler",
  text67: "Unterkunft deaktiviert.",
  text68: "Der Eigentümer hat die Check-ins deaktiviert.",
  text69: "Datum auswählen",
  text70: "Von - Bis",
  text71: "Option auswählen",
  text72: "Land auswählen *",
  text73: "Möchten Sie den Vorgang wirklich neu starten?",
  text74: "Sie verlieren die gespeicherten Daten",
  text75: "Check-in-Daten",
  text76: "Check-in-Unterschrift",
  text77: "Unterschrieben",
  text78: "Willkommen",
  text79: "Beim Abmelden ist leider ein Fehler aufgetreten",
  text80: "Vorgang abbrechen.",
  text81:
    "Das Anlegen der ersten Unterkunft ist für das ordnungsgemäße Funktionieren des Systems erforderlich.",
  text82: "Abbrechen und verlassen",
  text83: "Weiter bearbeiten",
  text84: "Suchen...",
  text85: "Keine Einträge gefunden",
  text86: "Zurück",
  text87: "Weiter",
  text88: "Möchten Sie es erneut versuchen oder den manuellen Vorgang nutzen?",
  text89: "Wird geladen ...",
  text90: "Services",
  text91: "Ausstellungsdatum des Dokuments",
  text92: "Das Feld Ausstellungsdatum des Dokuments ist erforderlich",
  p93: `Ihre Daten werden geladen...`,
  p94: `Buchungsdaten`,
  p95: `Willkommen`,
  p96: `Um mit dem Check-in fortzufahren, geben Sie bitte die folgenden
    Daten ein:`,
  p97: `Dieser Vorgang ist eine Demonstration, es werden keine Ihrer Daten gespeichert`,
  p98: `Sicherheitscode:`,
  p99: `Sicherheitscode der Unterkunft`,
  p101: `Geben Sie den Sicherheitscode ein`,
  p102: `Der Sicherheitscode ist falsch, bitte prüfen Sie ihn und versuchen Sie es
    erneut.`,
  p103: `Oder Sie können auch`,
  p104: `Nach Check-in-Code filtern`,
  p105: `Weiter`,
  p106: `Check-in-Code`,
  p107: `Geben Sie den Check-in-Code ein`,
  p108: `Der Check-in-Code ist in unserer Plattform nicht registriert, bitte prüfen Sie ihn und versuchen Sie es erneut.`,
  p109: `Code der Unterkunft eingeben`,
  p110: `Umweltfreundlicher Check-in`,
  p111: `Willkommen!`,
  p112: `Halten Sie bitte Ihren`,
  p112_1: `Ausweis oder Reisepass`,
  p112_2: `bereit, um fortzufahren`,
  p113: `Sie müssen die`,
  p114: ` Kamera-Berechtigungen 📷 akzeptieren`,
  p115: ` sie sind nötig, damit unser Scanner richtig funktioniert.`,
  p116: `Weiter`,
  p117: `Sprache auswählen`,
  p118: `Sicherheitscode eingeben`,
  p119: `Scannen Sie die Seite Ihres Reisepasses oder die Rückseite Ihres Personalausweises.`,
  p120: `Personalausweis`,
  p121: `Ausweis`,
  p122: `oder die Seite Ihres Reisepasses mit Ihrem Foto`,
  p123: `Um den Scanner zu nutzen, müssen die entsprechenden Berechtigungen für die
    Kamera erteilt werden.`,
  p124: `Sicherheitsprüfung ​🔐`,
  p125: `Zur Bestätigung Ihrer Nummer haben wir einen Code an Ihr`,
  p126: `WhatsApp`,
  p127: `Geben Sie ihn hier ein:`,
  p128: `Code eingeben`,
  p129: `Falscher Code, bitte prüfen Sie ihn und versuchen Sie es erneut`,
  p130: `Zurück`,
  p131: `Weiter`,
  p132: `Anreisedatum`,
  p133: `Abreisedatum`,
  p134: `Ablaufdatum`,
  p135: `Staatsangehörigkeit`,

  p136: `Mit dem Klick auf`,
  p137: ` erklären Sie sich damit einverstanden, das Formular mit Ihrem Namen zu unterschreiben, den Kurzzeitmietvertrag und die`,
  p138: `Datenschutzrichtlinien`,
  p139: `Unterschrift speichern`,
  p140: `Buchungsinformationen`,
  p141: `BUCHUNG:`,
  p142: `Anreise`,
  p143: `Abreise`,
  p144: `Bezahlen`,
  p145: `Bezahlt`,
  p146: `Zahlung wird geprüft`,
  p147: `Check-in`,
  p148: `Buchung`,
  p149: `Services`,
  p150: `IDENTITÄTSPRÜFUNG`,
  p151: `Laden Sie ein Selfie Ihres Gesichts bei guter Beleuchtung hoch`,
  p152: `In dieser Ansicht können Sie ein Foto der <strong>Vorderseite Ihres Ausweises hochladen`,
  p153: `In dieser Ansicht können Sie ein Foto der <strong>Rückseite Ihres Ausweises hochladen`,
  p154: `Kamera öffnen`,
  p155: `Erneut aufnehmen`,
  p156: `Identität prüfen`,
  p157: `Weiter`,
  p158: `Fehler bei der Prüfung Ihrer Identität.`,
  p159: `Bitte versuchen Sie es erneut.
    Machen Sie die Fotos an einem gut beleuchteten Ort und richten Sie Ihr Dokument mittig aus.`,
  p160: `Vorgang ist verpflichtend*`,
  p161: `Erneut versuchen`,
  p162: `Identität wird geprüft.`,
  p163: `Bitte warten ....`,
  p164: `Identität erfolgreich geprüft`,
  p165: `Sie haben Ihre Identität 🪪 erfolgreich bestätigt, der Check-in ist fast abgeschlossen 😎`,
  p166: `Auf Anfrage`,
  p167: `Um diesen Service anzufragen, müssen Sie Ihren Check-in durchführen.`,
  p168: `Fortschritt`,
  p169: `Ablaufdatum des Dokuments`,
  p170: `Anreisedatum`,
  p171: `Abreisedatum`,
  p172: `Telefon`,
  p173: `Ihr Dokument konnte nicht gescannt werden.`,
  p174: `Die Adresse gehört zu keiner Buchung im System`,
  p175: `Check-in-Informationen`,
  p176: `Support`,
  p177: `Spanisch (Spanien)`,
  p178: `Englisch`,
  p179: `Arabisch`,
  p180: `Ausweis`,
  p181: `Reisepass`,

  p182: `Verwandtschaftsverhältnis auswählen`,
  p183: `Sohn/Tochter`,
  p184: `Großvater/Großmutter`,
  p185: `Urgroßvater/Urgroßmutter`,
  p186: `Urenkel/Urenkelin`,
  p187: `Schwager/Schwägerin`,
  p188: `Ehepartner/in`,
  p189: `Bruder/Schwester`,
  p190: `Enkel/Enkelin`,
  p191: `Andere`,
  p192: `Vater oder Mutter`,
  p193: `Neffe/Nichte`,
  p194: `Schwiegervater/Schwiegermutter`,
  p195: `Onkel/Tante`,
  p196: `Vormund`,
  p197: `Schwiegersohn/Schwiegertochter`,

  p198: `Das Feld Verwandtschaftsverhältnis ist erforderlich`,
  p199: `Ausweis`,
  p200: `ANDERE`,
  p201: `Trägernummer des Dokuments`,
  p202: `Die Trägernummer des Dokuments ist erforderlich`,

  p203: `Nach dem Königlichen Dekret 933/2021 erforderliche Angaben`,
  p204: `Nach dem Königlichen Dekret 933/2021 vom 26. Oktober müssen wir Daten wie Ihre Adresse, Postleitzahl, Zahlungsart und das Zahlungsdatum erheben, um die Sicherheitsvorschriften zu erfüllen.`,
  p205: `Aktuelle Wohnadresse`,
  p206: `Adresse`,
  p207: `Postleitzahl`,
  p208: `Zahlungsart`,
  p209: `Zahlungsart auswählen`,
  p210: `Bargeld`,
  p211: `Zahlung bei Ankunft`,
  p212: `Kreditkarte`,
  p213: `Mobile Zahlung`,
  p214: `Zahlungsplattform`,
  p215: `Geschenkkarte`,
  p216: `Überweisung`,
  p217: `Zahlungsdatum`,
  p218: `Zahlungsart`,
  p219: `Zahlungsdatum`,
  p220: "Wohnsitzland",
  p221: "Wohnort",
  p222: "Wohnadresse",
  p223: "Postleitzahl des Wohnorts",

  p224: "Option auswählen",
  p225: "Sind Minderjährige in der Buchung?",
  p226: "Nein",
  p227: "Ja",
  p228: "Dokument nicht zulässig",
  p229: "Bitte prüfen Sie es und verwenden Sie Ihren gültigen Reisepass, um fortzufahren.",
  p230:`Scannen Sie Ihren Reisepass oder Personalausweis`,
  
  p231: `Das Abreisedatum darf nicht vor dem Anreisedatum liegen`,
  p232: `Gültige E-Mail-Adresse`,
  p233: `Pflichtfeld`,
  p234: `Die Ausweisnummer ist ungültig`,
  p235: `Das Abreisedatum darf nicht vor dem Abreisedatum liegen`,
  p236: `Sie müssen angeben, ob Kinder in der Buchung sind`,
  p237: `Sie müssen das Verwandtschaftsverhältnis angeben, wenn Kinder in der Buchung sind`,
  p238: `Fehler, der Vorgang kann nicht fortgesetzt werden`,
  p239: `Willkommen!`,
  p240: `Halten Sie bitte Ihren`,
  p241: `Ausweis oder Reisepass`,
  p242: `🪪 für den automatischen Vorgang bereit`,
  p243: `Bitte beachten Sie`,
  p244: `Das Akzeptieren der Kamera-Berechtigungen 📷`,
  p245: `ist nötig, damit unser Scanner richtig funktioniert`,
  p246: `Scannen Sie die Rückseite von Ihrem`,
  p247: `Schließen Sie hier Ihre Check-in-Anmeldung ab!`,
  p248: `Link in die Zwischenablage kopiert`,
  p249: `Weiteren Gast registrieren`,
  p250: `WhatsApp`,
  p251: `Link kopieren`,
  p252: `Unbekannte Zahlungsart`,
  p253: `Die Postleitzahl wurde in den Datensätzen nicht gefunden`,
  p254: `Erlebnisse und Services`,
  p255: `Alles, was Sie brauchen, um Ihren Aufenthalt voll zu genießen`,
};
